module.exports = __webpack_public_path__ + "img/mx.d326007c.svg";